document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-crumbs-expand]').forEach((button) => {
    button.addEventListener('click', () => {
      const crumbs = button.closest('.crumbs');

      crumbs?.querySelectorAll('.crumbs__item--expanded').forEach((item) => {
        item.style.setProperty('display', 'block', 'important');
      });

      crumbs?.querySelectorAll('.crumbs__item--minimal').forEach((item) => {
        item.style.setProperty('display', 'none', 'important');
      });
    });
  });
});
